module.exports = __webpack_public_path__ + "d0a3a6efa2f7ac7995b82a7a24fc89c7.svg";